import { api } from 'utils';
import { axiosConfig } from 'config';
import { getTagsAll } from './wp';

// Constantes do core (EnumerablePortal.Solutions) — categorias de soluções.
const SOLUTIONS_PAGE = 221;   // posts desta categoria definem os "segmentos"
const SOLUTIONS_PAGE_ID = 211; // página "Nossas Soluções" no WordPress (Elementor)
const DETAIL = 212;
const LINES = [
    { id: 217, categoryPosition: 0 }, // FullSolution
    { id: 218, categoryPosition: 0 }, // BooksCollection
    { id: 225, categoryPosition: 1 }, // Language
    { id: 226, categoryPosition: 1 }, // Socioemotional
    { id: 227, categoryPosition: 1 }, // Literature
    { id: 230, categoryPosition: 2 }, // Evaluation
    { id: 233, categoryPosition: 2 }  // PublicMarket
];

const getPosts = async (category, fields = 'id,slug,title,content,acf,tags,categories') => {
    try {
        const { data } = await api.get('/wp/v2/posts', {
            params: { categories: category, per_page: 100, _fields: fields }
        });
        return data || [];
    } catch (error) {
        return [];
    }
};

const stripHtml = (html) => String(html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

// Percorre o layout do Elementor e coleta os textos de headings/text-editor.
// Usado como fallback de descrição quando a página não tem excerpt.
const extractElementorText = (elements) => {
    const texts = [];
    const walk = (el) => {
        const s = el && el.settings ? el.settings : {};
        if (el && el.widgetType === 'heading' && s.title) texts.push(stripHtml(s.title));
        else if (el && el.widgetType === 'text-editor' && s.editor) texts.push(stripHtml(s.editor));
        if (el && Array.isArray(el.elements)) el.elements.forEach(walk);
    };
    (Array.isArray(elements) ? elements : []).forEach(walk);
    return texts.filter(t => t && t.length > 10);
};

// Busca a página real do WordPress (montada no Elementor) para extrair
// título/descrição e o conteúdo (elementor_data). Tudo com fallback para
// não quebrar a view se a página não existir ou não tiver dados.
const getSolutionsPage = async () => {
    try {
        const { data } = await api.get(`/wp/v2/pages/${SOLUTIONS_PAGE_ID}`, {
            params: { _fields: 'id,title,content,excerpt,acf,elementor_data,elementor_meta' }
        });
        return data || null;
    } catch (error) {
        return null;
    }
};

export const getSolutions = async () => {
    const [page, pagePosts] = await Promise.all([
        getSolutionsPage(),
        getPosts(SOLUTIONS_PAGE, 'tags')
    ]);

    const segmentTagIds = [...new Set(pagePosts.flatMap(p => p.tags || []))];
    const allTags = await getTagsAll();
    const segments = allTags
        .filter(t => segmentTagIds.includes(t.id))
        .map(tag => ({
            id: tag.id,
            title: tag.name,
            class: (tag.name.substring(tag.name.lastIndexOf(' ') + 1) || '').toLowerCase()
        }));

    const listCategory = [
        { id: 1, title: "Didáticos", bgColor: "#00648b", listContent: [] },
        { id: 2, title: "Complementares", bgColor: "#0096d3", listContent: [] },
        { id: 3, title: "Adicionais", bgColor: "#00c3dd", listContent: [] }
    ];

    for (const line of LINES) {
        const posts = await getPosts(line.id);
        if (!posts || !Array.isArray(posts)) continue;
        const categoryDetail = posts.find(p => Array.isArray(p?.categories) && p.categories.includes(DETAIL));
        if (!categoryDetail) continue;

        const content = {
            id: line.id,
            title: categoryDetail.title?.rendered || '',
            icon: {
                src: categoryDetail.acf?.imagem || '',
                alt: ""
            },
            listGroup: []
        };

        const ordered = posts
            .filter(p => p.id !== categoryDetail.id)
            .sort((a, b) => (a.acf?.ordem_de_exibicao || 0) - (b.acf?.ordem_de_exibicao || 0));

        let i = -1;
        ordered.forEach(post => {
            if (content.listGroup.length === 0 || post.acf?.subgrupo) {
                i++;
                content.listGroup.push({
                    id: i + 1,
                    title: post.acf?.subgrupo || '',
                    listBrands: []
                });
            }

            const postTags = allTags.filter(t => (post.tags || []).includes(t.id));
            content.listGroup[i].listBrands.push({
                id: post.id,
                segment: postTags.map(t => ({ id: t.id, title: t.name })),
                permalink: post.acf?.url_solucoes || '',
                src: post.acf?.imagem || '',
                alt: (post.acf?.url_solucoes || '').replace('/nossas-solucoes/', '')
            });
        });

        listCategory[line.categoryPosition].listContent.push(content);
    }

    // Título/descrição vêm da página real do WordPress quando disponíveis.
    const elementorTexts = extractElementorText(page?.elementor_data);
    const description =
        stripHtml(page?.excerpt?.rendered) ||
        (page?.acf?.descricao ? stripHtml(page.acf.descricao) : '') ||
        elementorTexts[0] ||
        "Conexões Santillana a favor do conhecimento";

    return {
        title: page?.title?.rendered || "Nossas Soluções",
        description,
        background: {
            src: page?.acf?.imagem_header || page?.acf?.imagem || `${axiosConfig.uploadsUrl}/2020/09/15144255/bg_solucoes-estendido1140.png`,
            alt: ""
        },
        page: {
            id: page?.id || null,
            content: page?.content?.rendered || '',
            elementor: !!page?.elementor_data,
            elementorMeta: page?.elementor_meta || null
        },
        listSegments: segments,
        listCategory
    };
};